export const MESSAGES_COUNT_SET = 'MESSAGES_COUNT_SET';

export const NOTIFICATIONS_COUNT_SET = 'NOTIFICATIONS_COUNT_SET';
